import { toast } from "react-toastify";
import requestUtil from "../../../../helpers/requestUtil";
import { setLoading } from "../../../common/Loader/slice";
import * as Toasts from '../../../common/Toastify';
import { resetError, resetParams, setCandidateSearchInfo, setError, setIsDataNotFound, setLoadingFlagDecrement, setLoadingFlagIncrement, setMasterData, setParams, setTotalCount, updateJobLevelList } from './slice';
import { localHostBaseURL } from "../../../../helpers/domainURL";
import { updateSharedSlice } from "../../../shared/sharedSlice";


export const updateParams = (data) => {
    return async dispatch => {
        dispatch(setParams(data));
    };
}

export const resetParamVal = () => {
    return async dispatch => {
        dispatch(resetParams());
    };
}

export const getCandidateSearchDetail = ({ url, params }) => {
    const newparams = { ...params };
    newparams.locationId = params.locationId ? params.locationId : 0;
    newparams.distanceId = params.distanceId ? params.distanceId : 0;
    newparams.distance = params.distance ? parseInt(params.distance) : 0;
    newparams.status = params.status.map(item => item.id);
    newparams.JobTypeIdList = params.JobTypeIdList.map(item => item.id);
    newparams.positions = params.positions.map((item) => item.id);
    newparams.department = params.department.map((item) => item.id);
    return async dispatch => {
        // dispatch(setLoading(true));
        dispatch(setLoadingFlagIncrement())
          // Employers/search-candidates-optimized
          // Employers/old-search-candidates-optimized
        try {
            const response = await requestUtil(`${url}/Employers/search-candidates-optimized`, 'POST', { ...newparams });
            formartData(response.candidateSearchList)
            dispatch(setCandidateSearchInfo(response.candidateSearchList));
            dispatch(setTotalCount(response.totalCount));
            if(response?.candidateSearchList?.length === 0){
                dispatch(setIsDataNotFound(true))
              } else {
                dispatch(setIsDataNotFound(false))
              }
        } catch (error) {
            dispatch(setError(error.message))
            dispatch(setIsDataNotFound(false))
        }
        // dispatch(setLoading(false));
        finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

export const loadMasterData = (baseUrl, empuniqueId) => {
    return async (dispatch, getState) => {
        // dispatch(setLoading(true));
        const state = getState();
        const locationSharedList = state.shared.locationSharedList;
        const distanceSharedList = state.shared.distanceSharedList;
        const statusSharedList = state.shared.statusSharedList;
        let location = locationSharedList ?? [];
        let travelDistance = distanceSharedList ?? [];
        let status = statusSharedList ?? [];
        let newstatus = statusSharedList?.length > 0 ?  statusSharedList?.filter(status => status?.name?.toLowerCase() !== "all") : [] 
        try {
            dispatch(setLoadingFlagIncrement())
            if(location?.length === 0){
                location = await requestUtil(`${baseUrl}/Locations/get-location-list-for-dropdown/${empuniqueId}`, 'GET');
                dispatch(updateSharedSlice({name:"locationSharedList",value:location}));
            }
            if(status?.length === 0){
                status = await requestUtil(`${baseUrl}/Dropdown/get-candidate-status-for-employer-search`, 'GET');
                newstatus =  status?.filter(st => st?.name?.toLowerCase() !== "all") 
                dispatch(updateSharedSlice({name:"statusSharedList",value:status}));
            } 
            // const newstatus = await requestUtil(`${baseUrl}/Dropdown/get-candidate-status-for-employer-status-update-dropdown`, 'GET');
            if(travelDistance?.length === 0){
                travelDistance = await requestUtil(`${baseUrl}/Dropdown/GetTravelDistances`, 'GET');
                dispatch(updateSharedSlice({name:"distanceSharedList",value:travelDistance}));
            }
            // const jobType = await requestUtil(`${baseUrl}/Employers/getjobtypes/${empuniqueId}`, 'POST', {});
            const jobtype = await requestUtil(`${baseUrl}/Employers/getjobtypes/${empuniqueId}`,'POST',{});
            const jobLevel = await requestUtil(
                `${baseUrl}/Employers/get-job-categories`,
                'POST',
                jobtype?.length ? { jobtypes: jobtype.map(item => item.id) } : { jobtypes: [] }
            );
            // location.unshift({id: "", name: "Select"})
            // console.log(location);

            dispatch(setMasterData({
                location, status, newstatus, travelDistance, jobType:jobtype, jobLevel: groupByDropDownFormat(
                    jobLevel.groupedOption
                )
            }));
        } catch (error) {
            dispatch(setError(error.message))
        }
        // dispatch(setLoading(false));
        finally {
            dispatch(setLoadingFlagDecrement())
        }
    };
}

const formartData = (data) => {
    data.map(item => {
        item.shiftsCompleted = `${item.shiftsCompleted} Shifts`;
        item.hoursWorked = item.hoursWorked ? `${item.hoursWorked} Hours` : '';
        item.distance = ` ${item.distance} miles`;
    });
}

export const updateStatus = ({ url, params }) => {
    return async dispatch => {
        // dispatch(setLoading(true));
        dispatch(setLoadingFlagIncrement())

        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            Toasts.success(response.message);
            return response?.result ? true : false;
            return response;
            // if(+response?.result === 1){
            //     let copyTableData = [...data];
            //     const upadteTableData = copyTableData?.map(data => {
            //     if(data?.candidateUniqueId === params?.candidateUniqueId ){
            //         return {...data,statusId:+params.candidateStatusForEmployer}
            //     } else {
            //         return data;
            //     }
            //     });
            //     formartData(upadteTableData)
            //     dispatch(setCandidateSearchInfo(upadteTableData));
            //     Toasts.success(response.message);
            // }
        } catch (error) {
            Toasts.error(error.message);
            dispatch(setError(error.message))
            return false;
        }
        // dispatch(setLoading(false));
        finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}

export const saveFavorite = ({ url, params }) => {
    return async dispatch => {
        // dispatch(setLoading(true));
        dispatch(setLoadingFlagIncrement())

        try {
            const response = await requestUtil(`${url}`, 'POST', { ...params });
            Toasts.success(response.message);
        } catch (error) {
            dispatch(setError(error.message))
        }
        // dispatch(setLoading(false));
        finally {
            dispatch(setLoadingFlagDecrement())
        }
    }
}

function groupByDropDownFormat(requestArray) {
    const newArray = [];
    if (requestArray && requestArray.length) {
        for (let index = 0; index < requestArray.length; index++) {
            const element = requestArray[index];
            const groupByLabel = element.label;
            const newOptions = element.options.map((e) => {
                return {
                    ...e,
                    groupByLabel,
                };
            });
            newArray.push(...newOptions);
        }
    }
    return newArray;
}


export function getJobLevel(url, requestBody) {
    return async (dispatch) => {
        // dispatch(setLoading(true));

        dispatch(setLoadingFlagIncrement());

        try {
            const jobLevelList = await requestUtil(
                `${url}/Employers/get-job-categories`,
                'POST',
                requestBody
            );
            const groupByDropDownResult = groupByDropDownFormat(
                jobLevelList.groupedOption
            );
            dispatch(updateJobLevelList(groupByDropDownResult));
        } catch (error) {
            // dispatch(setFailureLogs(error.message))
            dispatch(setError(error.message));
            // console.log(error);
        } finally {
            // dispatch(setLoading(false));
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function sendEmail({ url, params }) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, "POST", { ...params });
            Toasts.success("Email sent successfully!");
            return response;
        } catch (error) {
            Toasts.error("Email not sent!");
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function sendSMS({ url, params }) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, "POST", { ...params });
            Toasts.success("Sms sent successfully!");
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function getEmailDetails({ url }) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, "GET");
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function getSMSDetails({ url,params }) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, "POST",{...params});
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}


export function getOnCall({ url }) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, "GET");
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function getOffCall({ url }) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await requestUtil(`${url}`, "GET");
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function sendAllEmailbtn(url) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await fetch(url);
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}


export function sendAllSmsbtn(url) {
    return async (dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const response = await fetch(url);
            return response;
        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
        }
    };
}

export function getCallHistory(url, params) {
    return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
        const response = await requestUtil(
          `${url}/Voice/get-recordings`,
          'POST', params
        );;
        return response;
      } catch (error) {
        return error.message;
      } finally {
        dispatch(setLoadingFlagDecrement());
      }
    };
  }


  export const exportDetailsToExcel = ({baseUrl,params}) => {
    const login = JSON.parse(sessionStorage.getItem('login'));
    const  accessToken = login.accessToken;
    const newparams = { ...params };
    newparams.locationId = params.locationId ? params.locationId : 0;
    newparams.distanceId = params.distanceId ? params.distanceId : 0;
    newparams.distance = params.distance ? parseInt(params.distance) : 0;
    newparams.status = params.status.map(item => item.id);
    newparams.JobTypeIdList = params.JobTypeIdList.map(item => item.id);
    newparams.positions = params.positions.map((item) => item.id);
    newparams.department = params.department.map((item) => item.id);
    newparams.pageSize = 0;
    return async(dispatch) => {
        dispatch(setLoadingFlagIncrement());
        try {
            const requestHeaders = {
                'Content-Type': 'application/json',
                'Accept':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': accessToken ? `Bearer ${accessToken}` : '',
                'Website-Domain-Name': window.location.hostname === 'localhost' ? localHostBaseURL : window.location.hostname,
            };
           const result = await fetch(`${baseUrl}/Employers/export-candidates-search`, {
                headers:{...requestHeaders},
                method:"POST",
                body:JSON.stringify(newparams)
            })
            const data = await result.blob();
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'candidate_list.xlsx';
            a.click();

                  // Cleanup
            window.URL.revokeObjectURL(url);
             document.body.removeChild(a);

        } catch (error) {
            return error.message;
        } finally {
            dispatch(setLoadingFlagDecrement());
          }
    }
  }


  export const fetchDollarDetails = ({ url, params }) => {
    return async (dispatch) => {
      dispatch(setLoadingFlagIncrement());
      try {
        const result = await requestUtil(url, "POST", { ...params });
        if (result?.result) {
          return result?.candidatePayRateSetupList
        }
      } catch (error) {
        return error
      } finally {
        dispatch(setLoadingFlagDecrement());
      }
    }
  }
  